<template>
  <div id="app_content" class="public">
    <div class="content recovery-form">
      <form v-if="!success">
        <div class="back">
          <a :href="return_link">{{ trans.get("auth.return_link") }}</a>
        </div>
        <h2 class="mt-0">{{ trans.get("auth.recovery.title") }}</h2>

        <div class="email">
          <label for="">{{ trans.get("auth.recovery.label") }}</label>
          <input type="text" v-model="email_address" @blur="$v.$touch()" />
          <span class="error" v-if="$v.$dirty && !$v.email_address.required">{{
            trans.get("generali.email.required")
          }}</span>
          <span class="error" v-if="$v.$dirty && !$v.email_address.email">{{
            trans.get("generali.email.email")
          }}</span>
        </div>

        <button
          class="belt-btn animated"
          @click.prevent="sendRequest()"
          :disabled="$v.$invalid"
          :class="{ v_loading: loading }"
        >
          {{ trans.get("auth.recovery.request") }}
        </button>
      </form>

      <div v-else class="complete">
        {{ success }}
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
export default {
  data: function () {
    return {
      return_link: window.location.origin,
      email_address: "",
      success: false,
      loading: false,
    };
  },

  validations: {
    email_address: { required, email },
  },

  methods: {
    sendRequest: function () {
      var vue = this;

      if (vue.loading) return;

      vue.loading = true;

      axios({
        method: "post",
        url: window.location.origin + "/data/request-password-recovery",
        data: {
          email_address: vue.email_address,
        },
      })
        .then((res) => {
          vue.$store.commit("add_message", {
            type: "success",
            message: res.data.message,
          });

          console.log(res.data);

          // vue.success = res.data.message
        })
        .catch((err) => {
          vue.$store.commit("add_message", {
            type: "error",
            message: err.response.data.message,
          });

          console.log(err.response);
          console.log(res.data);
        })
        .then(() => {
          vue.loading = false;
        });
    },
  },
};
</script>

<style scoped>
#app_content {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--black);
}
.content {
  width: 800px;
  max-width: 95%;
  height: auto;
  padding: 4em;
  border: 1px solid white;
  background-color: white;
}
div.email {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
}
div.email input {
  width: 100%;
  padding: 13px 20px;
  border: 1px solid gray;
}
.back {
  text-align: right;
}
.back a {
  color: var(--blue);
  text-decoration: underline;
}
span.error {
  font-size: 0.85em;
  color: var(--red);
}
</style>
